import { render, staticRenderFns } from "./package-details.vue?vue&type=template&id=64647dfa&scoped=true"
import script from "./package-details.vue?vue&type=script&lang=js"
export * from "./package-details.vue?vue&type=script&lang=js"
import style0 from "./package-details.vue?vue&type=style&index=0&id=64647dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64647dfa",
  null
  
)

export default component.exports